import { colors, shadows } from './shibui';
import Color from 'color'

export const FORM_STYLES = {
  formWrap: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 575,
    minWidth: 300,
    minHeight: 200,
    borderRadius: 7,
    padding: '27px 31px',
    boxShadow: shadows.modal.boxShadow,
    backgroundColor: colors.ivory.color,
    '@media screen and (maxWidth: 700px)': {
      position: 'relative',
      transform: 'none',
      top: 0,
      left: 0,
      margin: '30px auto 0 auto',
      backgroundColor: 'transparent',
      boxShadow: 'none',
    }
  },
  input: {
    backgroundColor: colors.ivory.color,
    width: '100%',
    height: 45,
    borderRadius: 5,
    marginBottom: 15,
    marginTop: 5,
    backgroundColor: colors.ivory.color,
    border: '1px solid ' + Color(colors.ivory.color).darken(.7),
    fontSize: 14,
    paddingLeft: '15px',
    ':focus': {
      border: '1px solid ' + colors.amethyst50.color
    }
  },
  disabled: {
    color: '#AAA',
    fontStyle: 'italic'
  },
  errorInput: {
    border: '1px solid ' + Color('red').fade(0.1)
  },
  btn: {
    border: '2px solid ' + colors.seattleMuted.color,
    backgroundColor: 'transparent',
    borderRadius: 5,
    width: '100%',
    marginTop: 27,
    fontSize: 17,
    position: 'relative',
    lineHeight: 2.3,
    minHeight: 40,
    letterSpacing: 1.7,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    transition: 'background-color 125ms ease',
    ':focus': {
      border: '2px solid ' + colors.amethyst50.color
    }
  },
  btnDisabled: {
    backgroundColor: colors.seattle50.color,
    cursor: 'not-allowed'
  },
  btnLink: {
    backgroundColor: colors.tiger50.color,
    cursor: 'pointer',
    borderRadius: 5,
    width: '100%',
    height: 55,
    fontSize: 16,
    position: 'relative',
    lineHeight: 3.8,
    padding: '5px 20px',
    letterSpacing: 1.7,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    transition: 'background-color 125ms ease',
    ':hover': {
      backgroundColor: Color(colors.amethyst50.color).lighten(0.05)
    },
    ':focus': {
      border: '1px solid ' + colors.amethyst50.color
    },
    textDecoration: 'none'
  },
  error: {
    backgroundColor: Color('red').fade(0.5),
    color: 'white',
    width: 'calc(100% + 54px)',
    textAlign: 'center',
    padding: 20,
    margin: '0 0 12px -27px',
    fontSize: 14
  },
  spinner: {
    position: 'absolute',
    left: '50%',
    top: 18,
    transform: 'translate(-50%, -50%)'
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/forms-shared.js